<div class="mobile-slides-menu-container" [ngClass]="{ expanded: toggleState }">
    <div class="toggle" (click)="toggle()">
        <div>
            <app-icon [type]="'Arrow-down'"></app-icon>
        </div>
        <div class="text">{{ toggleState ? "Collapse" : "Expand" }}</div>
    </div>
    <div class="slide-menu-wrapper" *ngIf="toggleState">
        <div
            class="slide p-2 ps-7 mb-2"
            (click)="selectSlide(null)"
            *ngIf="hasIntro"
            [ngClass]="{ active: !currentSlide }"
        >
            Instructions
        </div>
        <div
            *ngFor="let slide of slides"
            class="slide p-2 ps-7 mb-2"
            (click)="selectSlide(slide)"
            [ngClass]="{ active: slide === currentSlide }"
            [innerHTML]="slide.name | bypassSecurity: 'html'"
        ></div>
    </div>
    <div class="controls">
        <div class="control-btn previous" (click)="clickPrevious.emit(true)">
            <app-icon [type]="'Arrow-left'"></app-icon>
        </div>
        <div class="count">{{ slideCount }} of {{ slides.length }}</div>

        <div class="control-btn next" (click)="clickNext.emit(true)">
            <span *ngIf="isLastSlide()">Submit</span>
            <app-icon [type]="'Arrow-right'"></app-icon>
        </div>
    </div>
</div>
